import { createSlice } from "@reduxjs/toolkit";
import {
  getClassifications,
  getClassificationsId,
  getClassificationsTax,
  classificationsAprroverTax,
  classificationsAprroverEng,
  classificationsSuspend,
  getDashboard,
  getClassificationsPn,
  getUserApprover,
  getUserDelete,
  getUserEngDelete,
  getUserEdit,
  getPutEdit,
  getPutEditCreaEng,
  getPutUserEngInternals,
  getUserEngInternals,
  getClassificationHistory,
} from "../actions/fluxoNSimilar";

interface ClassificationsState {
  sessionClassifications: any | null;
  sessionClassificationsid: any | null;
  sessionClassificationstax: any | null;
  sessionClassificationseng: any | null;
  sessionDashboard: any | null;
  sessionMaterial: any | null;
  sessionUsers: any | null;
  sessionUsersEng: any;
  sessionUsersDelete: any | null;
  sessionUsersEngDelete: any;
  sessionUsersEdit: any | null;
  sessionUsersEditCreaEng: any;
  sessionUsersEngInternals: any;
  sessionClassificationHistory: any;
  sessionMaterialPn: any | null;
  status: "idle" | "loading" | "ready" | "error";
  error: unknown | null;
  httpStatus: number | null;
  messageStatus: string | null;
}

const initialState: ClassificationsState = {
  sessionClassifications: null,
  sessionClassificationsid: null,
  sessionClassificationstax: null,
  sessionClassificationseng: null,
  sessionDashboard: null,
  sessionMaterial: null,
  sessionUsers: null,
  sessionUsersEng: null, 
  sessionUsersDelete: null,
  sessionUsersEngDelete: null,
  sessionUsersEdit: null,
  sessionUsersEditCreaEng: null, 
  sessionUsersEngInternals: null,
  sessionClassificationHistory: null,
  sessionMaterialPn: null,
  status: "idle",
  error: null,
  httpStatus: null,
  messageStatus: null,
};
const sessionClassificationsSlice = createSlice({
  name: "sessionClassifications",
  initialState,
  reducers: {
    resetClear(state) {
      return initialState;
    },
    resetClassifications(state) {
      // sessionClassifications e sessionClassificationstax precisam ser objetos
      state.sessionClassifications = { content: [], page: 0 };
      state.sessionClassificationstax = { content: [], page: 0 };

      // sessionClassificationsid continua string
      state.sessionClassificationsid = "";

      // sessionDashboard e sessionMaterial podem ser objetos vazios
      state.sessionDashboard = {};
      state.sessionMaterial = {};

      // sessionMaterialPn também como objeto vazio
      state.sessionMaterialPn = {};
    },

    getIdClassifications(state, action) {
      state.sessionClassificationsid = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getClassifications.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.httpStatus = null;
      })
      .addCase(getClassifications.rejected, (state, action) => {
        state.status = "error";
        if (state.sessionClassifications) {
          state.sessionClassifications.content = [];
          state.sessionClassifications.page = 0;
        }
        state.httpStatus =
          action.payload?.httpStatus ?? action.error?.status ?? 500;
        state.messageStatus = action.error.message;
      })
      .addCase(getClassifications.fulfilled, (state, action) => {
        state.status = "ready";
        state.sessionClassifications = action.payload.message;
        state.error = null;
        state.httpStatus = 200;
      })
      .addCase(getClassificationsTax.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.httpStatus = null;
      })
      .addCase(getClassificationsTax.rejected, (state, action) => {
        state.status = "error";
        if (state.sessionClassificationstax) {
          state.sessionClassificationstax.content = [];
          state.sessionClassificationstax.page = 0;
        }
        state.httpStatus =
          action.payload?.httpStatus ?? action.error?.status ?? 500;
        state.messageStatus = action.error.message;
      })
      .addCase(getDashboard.fulfilled, (state, action) => {
        state.status = "ready";
        state.sessionDashboard = action.payload;
        state.error = null;
        state.httpStatus = 200;
      })
      .addCase(getDashboard.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.httpStatus = null;
      })
      .addCase(getDashboard.rejected, (state, action) => {
        state.status = "error";
        if (state.sessionDashboard) {
          state.sessionDashboard.content = [];
        }
        state.httpStatus =
          action.payload?.httpStatus ?? action.error?.status ?? 500;
        state.messageStatus = action.error.message;
      })
      .addCase(getClassificationsTax.fulfilled, (state, action) => {
        state.status = "ready";
        state.sessionClassificationstax = action.payload.message;
        state.error = null;
        state.httpStatus = 200;
      })
      .addCase(getClassificationsId.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.httpStatus = null;
      })
      .addCase(getClassificationsId.rejected, (state, action) => {
        state.status = "error";
        state.sessionMaterial = "";
        state.error = action.payload;
        state.httpStatus =
          action.payload?.httpStatus ?? action.error?.status ?? 500;
        state.messageStatus = action.error.message;
      })
      .addCase(getClassificationsId.fulfilled, (state, action) => {
        state.status = "ready";
        state.sessionMaterial = action.payload.message;
        state.error = null;
        state.httpStatus = 200;
      })
      .addCase(getClassificationsPn.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.httpStatus = null;
      })
      .addCase(getClassificationsPn.rejected, (state, action) => {
        state.status = "error";
        state.sessionMaterialPn = "";
        state.error = action.payload;
        state.httpStatus =
          action.payload?.httpStatus ?? action.error?.status ?? 500;
        state.messageStatus = action.error.message;
      })
      .addCase(getClassificationsPn.fulfilled, (state, action) => {
        state.status = "ready";
        state.sessionMaterialPn = action.payload.message;
        state.error = null;
        state.httpStatus = 200;
      })

      .addCase(getUserApprover.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.httpStatus = null;
      })
      .addCase(getUserApprover.rejected, (state, action) => {
        state.status = "error";
        state.sessionUsers = "";
        state.httpStatus = action.payload?.httpStatus ?? 403;

        state.messageStatus =
          action.payload?.message ?? action.error.message ?? "Erro approver";
      })
      .addCase(getUserApprover.fulfilled, (state, action) => {
        state.status = "ready";
        state.sessionUsers = action.payload.message;
        state.error = null;
        state.httpStatus = 200;
      })

      .addCase(getUserEngInternals.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.httpStatus = null;
      })
      .addCase(getUserEngInternals.rejected, (state, action) => {
        state.status = "error";
        state.sessionUsersEng = "";

        state.httpStatus =
          action.payload?.httpStatus ?? 403;

        state.messageStatus =
          action.payload?.message ??
          action.error.message ??
          "Erro interno";
      })
      .addCase(getUserEngInternals.fulfilled, (state, action) => {
        state.status = "ready";
        state.sessionUsersEng = action.payload.message;
        state.error = null;
        state.httpStatus = 200;
      })

      .addCase(getClassificationHistory.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.httpStatus = null;
      })
      .addCase(getClassificationHistory.rejected, (state, action) => {
        state.status = "error";
        state.sessionClassificationHistory = { content: [], page: {} };
        state.httpStatus = action.payload?.httpStatus ?? 403;
        state.messageStatus =
          action.payload?.message ??
          action.error.message ??
          "Erro ao carregar histórico";
      })
      .addCase(getClassificationHistory.fulfilled, (state, action) => {
        state.status = "ready";
        state.sessionClassificationHistory = action.payload;
        state.error = null;
        state.httpStatus = 200;
      })

      .addCase(getUserDelete.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.httpStatus = null;
      })
      .addCase(getUserDelete.rejected, (state, action) => {
        state.status = "error";
        state.sessionUsersDelete = "";
        state.error = action.payload;
        state.httpStatus =
          action.payload?.httpStatus ?? action.error?.status ?? 500;
        state.messageStatus = action.error.message;
      })
      .addCase(getUserDelete.fulfilled, (state, action) => {
        state.status = "ready";
        state.sessionUsersDelete = action.payload;
        state.error = null;
        state.httpStatus = 200;
      })

      .addCase(getUserEngDelete.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.httpStatus = null;
      })
      .addCase(getUserEngDelete.rejected, (state, action) => {
        state.status = "error";
        state.sessionUsersEngDelete = "";
        state.error = action.payload;
        state.httpStatus =
          action.payload?.httpStatus ?? action.error?.status ?? 500;
        state.messageStatus = action.error.message;
      })
      .addCase(getUserEngDelete.fulfilled, (state, action) => {
        state.status = "ready";
        state.sessionUsersEngDelete = action.payload;
        state.error = null;
        state.httpStatus = 200;
      })

      .addCase(getUserEdit.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.httpStatus = null;
      })
      .addCase(getUserEdit.rejected, (state, action) => {
        state.status = "error";
        state.sessionUsersEdit = "";
        state.error = action.payload.message;
        state.httpStatus =
          action.payload?.httpStatus ?? action.error?.status ?? 500;
        state.messageStatus = action.error.message;
      })
      .addCase(getUserEdit.fulfilled, (state, action) => {
        state.status = "ready";
        state.sessionUsersEdit = action.payload.message;
        state.error = null;
        state.httpStatus = 200;
      })

      .addCase(getPutEdit.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.httpStatus = null;
      })
      .addCase(getPutEdit.rejected, (state, action) => {
        state.status = "error";
        state.sessionUsersEdit = "";
        state.error = action.payload;
        state.httpStatus = 500;
      })
      .addCase(getPutEdit.fulfilled, (state, action) => {
        state.status = "ready";
        state.sessionUsersEdit = action.payload;
        state.error = null;
        state.httpStatus = 200;
      })

      .addCase(getPutEditCreaEng.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.httpStatus = null;
      })
      .addCase(getPutEditCreaEng.rejected, (state, action) => {
        state.status = "error";
        state.sessionUsersEditCreaEng = "";
        state.error = action.payload;
        state.httpStatus = 500;
      })
      .addCase(getPutEditCreaEng.fulfilled, (state, action) => {
        state.status = "ready";
        state.sessionUsersEditCreaEng = action.payload;
        state.error = null;
        state.httpStatus = 200;
      })

      .addCase(getPutUserEngInternals.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.httpStatus = null;
      })
      .addCase(getPutUserEngInternals.rejected, (state, action) => {
        state.status = "error";
        state.sessionUsersEngInternals = "";
        state.error = action.payload;
        state.httpStatus = 500;
      })
      .addCase(getPutUserEngInternals.fulfilled, (state, action) => {
        state.status = "ready";
        state.sessionUsersEngInternals = action.payload;
        state.error = null;
        state.httpStatus = 200;
      })

      .addCase(classificationsAprroverTax.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.httpStatus = null;
      })
      .addCase(classificationsAprroverTax.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
        state.httpStatus = action.payload?.httpStatus || null;
      })
      .addCase(classificationsAprroverTax.fulfilled, (state, action) => {
        state.status = "idle";
        state.sessionClassificationstax = {
          ...state.sessionClassificationstax,
          message: action.payload.message,
        };
        state.error = null;
        state.httpStatus = 200;
      })

      .addCase(classificationsAprroverEng.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.httpStatus = null;
      })
      .addCase(classificationsAprroverEng.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
        state.httpStatus = action.payload?.httpStatus || null;
      })
      .addCase(classificationsAprroverEng.fulfilled, (state, action) => {
        state.status = "idle";
        state.sessionClassificationseng = {
          ...state.sessionClassificationseng,
          message: action.payload.message,
        };
        state.error = null;
        state.httpStatus = 200;
      })
      .addCase(classificationsSuspend.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.httpStatus = null;
      })
      .addCase(classificationsSuspend.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
        state.httpStatus = action.payload?.httpStatus || null;
      })
      .addCase(classificationsSuspend.fulfilled, (state, action) => {
        state.status = "idle";
        state.sessionClassificationstax = {
          ...state.sessionClassificationstax,
          message: action.payload.message,
        };
        state.error = null;
        state.httpStatus = 200;
      });
  },
});

export const { resetClear, resetClassifications, getIdClassifications } =
  sessionClassificationsSlice.actions;
export default sessionClassificationsSlice.reducer;
